import React from 'react';
import TituloFollajeArtificial from '../components/sections/FollajeArtificial/TituloFollajeArtificial';
import IntroFollajeArtificial from '../components/sections/FollajeArtificial/IntroFollajeArtificial';
import FollajeTabs from '../components/sections/FollajeArtificial/FollajeTabs'; // Nuevo componente
import CaracteristicasFollaje from '../components/sections/FollajeArtificial/CaracteristicasFollaje';
import CalculadoraCTAFollaje from '../components/sections/FollajeArtificial/CalculadoraCTAFollaje';
import FormularioContactoFollaje from '../components/sections/FollajeArtificial/FormularioContactoFollaje';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const FollajeArtificialPage = () => {
    return (
        <div>
            <Header />
            <TituloFollajeArtificial />
            <IntroFollajeArtificial />
            <FollajeTabs />  {/* Reemplaza el selector y las seis secciones de modelos */}
            <CaracteristicasFollaje />
            {/*<CalculadoraCTAFollaje />*/}
            <FormularioContactoFollaje />
            <Footer />
        </div>
    );
};

export default FollajeArtificialPage;